import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class ConfirmationAmountGiftAid extends Component {
	render() {
		return (
			<p className="ppvx_text--lg text-center"> + {this.props.extraDonateAmount} {this.props.giftAid}</p>
		);
	}
}

export default ConfirmationAmountGiftAid;

ConfirmationAmountGiftAid.propTypes = {
	extraDonateAmount: PropTypes.string,
	giftAid: PropTypes.string
}